export const resizeBase64Img = (base64Image: string, maxHeight: number): Promise<string> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    const image = new Image();

    image.onload = function imageOnLoad() {
      try {
        const ratio = maxHeight < image.naturalHeight ? maxHeight / image.naturalHeight : 1;
        canvas.width = image.naturalWidth * ratio;
        canvas.height = image.naturalHeight * ratio;
        ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth * ratio,
          image.naturalHeight * ratio);
        resolve(canvas.toDataURL());
      } catch (ex) {
        console.error(ex);
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('');
      }
    };

    image.src = base64Image;
  });
};
